import React, { useEffect, useState } from "react";
import styles from "@/pages/css/CreateProjectPage.module.css";

import { CreateProjectData } from "@/types/project";
import { useTranslation } from "react-i18next";
import { InputField } from "@/components/inputFields/inputFields";
import TextField from "@/components/inputFields/TextFeild";
import { UploadFilesTableData, FilesTypes } from "@/types/file";
import UploadFilesTable from "@/components/tables/UploadFilesTable";
import { UploadAndViewFiile } from "@/components/cards/UploadAndViewFiile";
import { CreateProjectFilelds } from "./CreateProjectFilelds";


export const CreateProject: React.FC<{
    onChange: (data: CreateProjectData) => void;
    data: CreateProjectData;
    setStepsCompleted: React.Dispatch<React.SetStateAction<boolean[]>>;
    projectFiles: UploadFilesTableData[];
    onUploadFile: (type: FilesTypes, file: File) => void;
    fieldsCompleted: boolean;
    isProjectNameExists: boolean;
    setFieldsCompleted: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ onChange, data, setStepsCompleted, projectFiles, onUploadFile, fieldsCompleted, setFieldsCompleted, isProjectNameExists }) => {
    const { t } = useTranslation("CreateProjectPage");
    const [blueLineFile, setBlueLineFile] = useState<File | null>(null);
    const [blueLineFileUrl, setBlueLineFileUrl] = useState<string | null>(null);
    const [blockError, setBlockError] = useState<string | null>(null);
    const [plotError, setPlotError] = useState<string | null>(null);
    
    useEffect(() => {
        if (projectFiles) {
            const blueLineFile = projectFiles.find(file => file.type === "blue line")?.file;
            if (typeof blueLineFile === "string") {
                setBlueLineFile(null);
                setBlueLineFileUrl(blueLineFile);
            } else {
                setBlueLineFile(blueLineFile as File);
                setBlueLineFileUrl(null);
            }
        }
    }, [projectFiles]);

    const handleChange = (data: CreateProjectData) => {
        onChange(data);
        setStepsCompleted(prev => {
            const newSteps = [...prev];
            newSteps[0] = Boolean(data.name) && !isProjectNameExists && fieldsCompleted;
            return newSteps;
        });
    }

    useEffect(() => {
        setStepsCompleted(prev => {
            const newSteps = [...prev];
            newSteps[0] = Boolean(data.name) && 
                         !isProjectNameExists &&
                         fieldsCompleted && 
                         (Boolean(data.residential_area_existing) || Boolean(data.residental_unit_area_existing) || 
                          (!data.residential_area_existing && !data.residental_unit_area_existing));
            return newSteps;
        });
    }, [data, fieldsCompleted, isProjectNameExists]);

    return <div className={styles.pahseContainerOnePage}>
        <div className={styles.row}>
            <div className={styles.titleElementComponent}>
                {/* <div className={styles.inputTitle}>{t("blueLine")}</div>
                {blueLineFileUrl? <UploadAndViewFiile type="blue line" fileUrl={blueLineFileUrl} /> : <UploadAndViewFiile file={blueLineFile} type="blue line" />} */}
            </div>
            <div className={styles.fileDataContainer}>
                <div className={styles.rowMini}>
                    <div className={styles.titleElementComponent}>
                        <div className={styles.inputTitle}>{t("projectName")}</div>
                        <InputField small={true} 
                            inputType="text" 
                            data={data.name || ''} 
                            setData={(value) => handleChange({ ...data, name: value || '' })} 
                            id="projectName" 
                            showError={isProjectNameExists}
                            errorMessage={isProjectNameExists ? "שם הפרוייקט קיים במערכת" : ""}
                        />
                    </div>
                    <div className={styles.titleElementComponent}>
                        <div className={styles.inputTitle}>
                            {"גוש" }
                        </div>
                        <div className={styles.inputWrapper}>
                            <InputField
                                small={true}
                                inputType="text"
                                data={data.block || ''}
                                setData={(value) => {
                                    handleChange({ ...data, block: value || undefined });
                                }}
                                id="block"
                                showError={false}
                            />
                        </div>
                    </div>
                    <div className={styles.titleElementComponent} >
                        <div className={styles.inputTitle}>
                            {"חלקה" }
                        </div>
                        <div className={styles.inputWrapper}>
                            <InputField
                                small={true}
                                inputType="text"
                                data={data.plot || ''}
                                setData={(value) => {
                                    handleChange({ ...data, plot: value || undefined });
                                }}
                                id="plot"
                                showError={false}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.titleElementComponent}>
                    <div className={styles.inputTitle}>{t("projectDescription")}</div>
                    <TextField id="projectDescription" placeholder="" text={data.description as string} setText={(value) => handleChange({ ...data, description: value })} size="large" showCharCount={false}/>
                </div>
            </div>
        </div>
        <div className={`${styles.rowContainerOnePage} mt-[10px]`}>
            <div className={styles.titleElementComponent}>
                <div className={styles.inputTitle}>{t("files")}</div>
                <div className={styles.filesContainer}>
                    <UploadFilesTable 
                        dataTestId="projectFiles"
                        files={projectFiles}
                        onUploadFile={onUploadFile}
                        showFull={true}
                        rows={1}
                    />
                </div>
            </div>
        </div>
        <CreateProjectFilelds onChange={handleChange} data={data} setStepsCompleted={setFieldsCompleted}/>
    </div>;
};
